import React from 'react';
import { cx } from './classNames';
import './ui.css';

export type SkeletonVariant = 'line' | 'block';
export type SkeletonWidth = 'full' | 'half' | 'third' | 'quarter';
export type SkeletonHeight = 'sm' | 'md' | 'lg';

export interface SkeletonProps {
  variant?: SkeletonVariant;
  /** 幅のプリセット。細かい寸法が要る場合は className で上書きする */
  width?: SkeletonWidth;
  /** block のみ有効 */
  height?: SkeletonHeight;
  /** line のみ有効。行数分を縦に並べる */
  lines?: number;
  className?: string;
}

export function Skeleton({ variant = 'line', width = 'full', height = 'md', lines = 1, className }: SkeletonProps) {
  const base = cx(
    'ui-skeleton',
    `ui-skeleton--${variant}`,
    `ui-skeleton--w-${width}`,
    variant === 'block' && `ui-skeleton--h-${height}`,
    className,
  );

  if (variant === 'line' && lines > 1) {
    return (
      <span className="ui-skeleton-group" aria-hidden="true" data-testid="ui-skeleton">
        {Array.from({ length: lines }, (_, i) => (
          // 最終行だけ短くして「文章」に見せる
          <span key={i} className={i === lines - 1 ? cx(base, 'ui-skeleton--w-half') : base} />
        ))}
      </span>
    );
  }

  return <span className={base} aria-hidden="true" data-testid="ui-skeleton" />;
}
